import { inject, Injectable } from '@angular/core';
import { IsoTime } from '../types/iso-date';
import { TimeZoneService } from './time-zone.service';
import { isIsoTime } from '../functions/validation/is-iso-time.function';
import { AbstractTimeService } from './abstract-time.service';

@Injectable({ providedIn: 'root' })
export class TimeService extends AbstractTimeService<IsoTime> {
  timeZoneService = inject(TimeZoneService);
  override now(): IsoTime {
    const now = new Date();
    const timeZone = this.timeZoneService.timeZone();
    return formatTime(now, timeZone) as IsoTime;
  }

  override midnight(): IsoTime {
    return '00:00:00.000' as IsoTime;
  }

  override isValid(date: string): date is IsoTime {
    return isIsoTime(date);
  }
}

function formatTime(date: Date, timeZone: string): string {
  const svDate = new Intl.DateTimeFormat('sv-SE', {
    timeZone: timeZone,
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false
  }).format(date);
  // svDate expected format: "HH:mm:ss"
  const timePart = svDate;

  const ms = date.getMilliseconds().toString().padStart(3, '0');
  return `${timePart}.${ms}`;
}
